import { layout } from 'src/styles/layout';
import styled from 'styled-components';

const confettiShapePlumTriangle = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMyAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjQwMzQgMTkuNTE5NUwyLjQ2ODMgMi45MzQzTDIwLjE3OTQgMS43MTY0M0wyMS40MDM0IDE5LjUxOTVaIiBzdHJva2U9IiM4OTAyNkMiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K';
const confettiShapeGrayHexagon = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQ1IiBoZWlnaHQ9IjM4MiIgdmlld0JveD0iMCAwIDM0NSAzODIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03OC4xNzA5IDAuOTcyODI0TDAuOTE1MzM5IDE4MS44NTlMNzEuODkyMSAzMjMuNzJMMjY4LjMzNSAzODEuMDU1TDM0NC42NTcgMTg3LjI1TDI3Ny42OTggNTMuNDE3OUw3OC4xNzA5IDAuOTcyODI0WiIgZmlsbD0iIzYwN0Q4QiIvPgo8L3N2Zz4K';
const confettiShapeOrangleHexagonOutline = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAyNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuMTcyNDMgMjIuNDI2MkwxMi42Nzc3IDM0LjAzNThMMjQuMTgzMSAyMi40MjYzTDI0LjE4MzEgMTMuMDIwOEwxMi42Nzc3IDEuNTE1ODFMMS4xNzI0NSAxMy4wMjA3TDEuMTcyNDMgMjIuNDI2MloiIHN0cm9rZT0iI0UwNDI0NyIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=';
const confettiShapeBlueTriangle = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjM4IiBoZWlnaHQ9IjM0OCIgdmlld0JveD0iMCAwIDIzOCAzNDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjg5MTExIDMxNi44MDNMMjA4Ljk0NCAyMDUuNDA3TDU0IDMuMTAxODFMMS44OTExMSAzMTYuODAzWiIgc3Ryb2tlPSIjODBEMUNEIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTE3Ljc1NjYgMjk3LjQ1MkwxOTAuNjcxIDIwMi4zOTFMNjIgMzEuMTAxOEwxNy43NTY2IDI5Ny40NTJaIiBzdHJva2U9IiM4MEQxQ0QiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMzEuMjk0NCAyODAuMDc0TDE3Mi4xOTIgMjAwLjc4NEw2OCA1OS4xMDE4TDMxLjI5NDQgMjgwLjA3NFoiIHN0cm9rZT0iIzgwRDFDRCIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik00Ni4zMjM3IDI1OS43MzZMMTUzLjk5NSAxOTcuMzkxTDc1IDg3LjEwMThMNDYuMzIzNyAyNTkuNzM2WiIgc3Ryb2tlPSIjODBEMUNEIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTYwLjM1MzEgMjM3LjM5OUwxMzMuODEyIDE5MS44MzVMODEgMTEzLjEwMkw2MC4zNTMxIDIzNy4zOTlaIiBzdHJva2U9IiM4MEQxQ0QiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNNzMuMzgyNCAyMTcuMDYxTDExNy41NjIgMTg5LjA5OEw4NiAxNDEuMTAyTDczLjM4MjQgMjE3LjA2MVoiIHN0cm9rZT0iIzgwRDFDRCIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik04Ni43NTYzIDE5OC42NjlMMTA0LjkxMiAxODcuMDE0TDkyIDE2Ny4xMDJMODYuNzU2MyAxOTguNjY5WiIgc3Ryb2tlPSIjODBEMUNEIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==';

export const WorkCultureContainer = styled.div`
  max-width: 100vw !important;
  position: relative;
  padding: 14rem 3rem 0.35rem;

  @media all and (max-width: ${layout.xs}) {
    padding: 14rem 1.5rem 0.35rem;
  }
`

export const WorkCultureConfetti = styled.div`
  position: absolute;
  width: 100vw;
  top: 0;
  bottom: 0;
  z-index: 2;
  background:
    url(${confettiShapePlumTriangle}) left 42% / 15px auto no-repeat,
    url(${confettiShapeGrayHexagon}) left 50% / 40% auto no-repeat,
    url(${confettiShapeOrangleHexagonOutline}) 83% 44% / 15px auto no-repeat,
    url(${confettiShapeBlueTriangle}) 90% calc(100% + 3%) / 35% auto no-repeat;

  @media screen and (min-width: ${layout.subLg}) {
    background:
      url(${confettiShapeGrayHexagon}) 15% 50% / 300px auto no-repeat,
      url(${confettiShapePlumTriangle}) 36% 44% / 20px auto no-repeat,
      url(${confettiShapeOrangleHexagonOutline}) 63% 47% / 18px auto no-repeat,
      url(${confettiShapeBlueTriangle}) 80% 50% / 200px auto no-repeat;
  }
`

export const WorkCultureText = styled.div`
  max-width: 1210px;
  display: grid;
  position: relative;
  z-index: 3;
  row-gap: 2rem;
  margin: 0 auto 5rem;

  p {
    max-width: 860px;
    justify-self: center;
  }
`

// parseInt is used to support min-width, instead of max-width, max-width: 700px and min-width: 700px overlap.
export const ImageWrapper = styled.div`
  display: none;
  position: relative;
  width: 1100px;
  margin: 0 auto 5rem;
  z-index: 2;
  max-width: 90vw;

  @media all and (min-width: ${parseInt(layout.subMd.replace('px', ''))+1}px) {
    display: grid;
  }
`

// 8rem in media query is inteded to leave some space around the image
export const ImageWrapperMobile = styled.div`
  position: relative;
  width: 1100px;
  margin: 0 auto 5rem;
  z-index: 2;
  max-width: 90vw;
  display: none;

  @media all and (max-width: ${layout.subMd}) {
    display: grid;
    max-width: calc(100vw - 8rem);
  }
  @media all and (max-width: ${layout.xs}) {
    max-width: 100%;
  }
`
